import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetVacantLandSalesError,
  GetVacantLandSalesVariables,
  fetchGetVacantLandSales,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getVacantLandSales;

export function useGetVacantLandSales(
  variables: GetVacantLandSalesVariables,
  opts?: UseQueryOptions<Response, GetVacantLandSalesError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetVacantLandSalesError>(
    queryKeyFn({
      path: '/api/v2/orders/{orderID}/attachments/vacantLandSales',
      operationId: 'getVacantLandSales',
      variables,
    }),
    async () => {
      const res = await fetchGetVacantLandSales({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
